const styles: Record<string, React.CSSProperties> = {
  userPopupBase: {
    position: "relative",
    height: "inherit",
    overflowY: "auto",
  },
  userPopupContainer: {
    width: "calc(100% - 4rem)",
    marginTop: "2rem",
    marginBottom: "2rem",
  },
};

export default styles;
